import { PageId } from "../../common/pageId"
import { AirportSeasonConfiguration } from "../../api/AirportSeasonConfiguration"
import { PageTitle } from "../../common/pageText"
import { CodeType } from "../../components/AirportSelector"
import { constraintQuotaValues } from "../../components/Utils"

type mapType = { [key: string]: any }

const {
  week,
  weekOutOfHours,
  seasonDayOperation,
  seasonTime,
  weekHour,
  seasonHour,
  baselinePeakWeek,
  detailWeek,
  detailWeekOOH,
  detailSeason
} = PageTitle

export const getPageConfig = (
  config: AirportSeasonConfiguration,
  NextPrevRequest: boolean,
  constraintType: string
): mapType => {
  const OverlayQuotaHidden = constraintQuotaValues.includes(constraintType)
  const overlayQuotaConstraintsHidden =
    config && config.supportsQuotaOverlay === false
      ? true
      : false || OverlayQuotaHidden

  const useHourlyConstraints = config && config.hiddenControls.length > 0

  const terminalHidden =
    constraintType === "Runway" && !(config && config.supportsRunwayTerminals)

  const peakWeekHidden =
    config === null ||
    config.peakWeekDate === null ||
    config.peakWeekDate === ""
      ? true
      : false

  return {
    [PageId.AvailWeek]: {
      pageTitle: week,
      flightSelectorConfig: {
        terminal: terminalHidden,
        overlayQuotaConstraints: overlayQuotaConstraintsHidden,
        adt: true,
        doop: true,
        dayOfWeek: true,
        hour: true,
        useHourlyConstraints: true,
        peakWeek: peakWeekHidden,
        nextPrev: true,
        goBack: true
      },
      airportseasonSelectorConfig: {
        selectCodeType: true,
        dropdownMultiSelect: false
      }
    },
    [PageId.AvailWeekOOH]: {
      pageTitle: weekOutOfHours,
      flightSelectorConfig: {
        terminal: terminalHidden,
        overlayQuotaConstraints: overlayQuotaConstraintsHidden,
        adt: true,
        doop: true,
        dayOfWeek: true,
        hour: true,
        useHourlyConstraints: true,
        peakWeek: peakWeekHidden,
        nextPrev: true,
        goBack: true
      },
      airportseasonSelectorConfig: {
        selectCodeType: true,
        dropdownMultiSelect: false
      }
    },
    [PageId.AvailDoop]: {
      codeType: CodeType.IATA,
      pageTitle: seasonDayOperation,
      flightSelectorConfig: {
        terminal: terminalHidden,
        overlayQuotaConstraints: overlayQuotaConstraintsHidden,
        hour: true,
        useHourlyConstraints: true,
        date: true,
        peakWeek: peakWeekHidden,
        nextPrev: true,
        goBack: true
      },
      airportseasonSelectorConfig: {
        selectCodeType: true,
        dropdownMultiSelect: false
      }
    },
    [PageId.AvailTime]: {
      codeType: CodeType.IATA,
      pageTitle: seasonTime,
      flightSelectorConfig: {
        terminal: terminalHidden,
        overlayQuotaConstraints: overlayQuotaConstraintsHidden,
        useHourlyConstraints: true,
        date: true,
        adt: true,
        doop: true,
        dayOfWeek: true,
        peakWeek: true,
        nextPrev: true,
        goBack: true
      },
      airportseasonSelectorConfig: {
        selectCodeType: true,
        dropdownMultiSelect: false
      }
    },
    [PageId.AvailWeekHour]: {
      codeType: CodeType.IATA,
      pageTitle: weekHour,
      flightSelectorConfig: {
        terminal: terminalHidden,
        overlayQuotaConstraints: overlayQuotaConstraintsHidden,
        useHourlyConstraints,
        adt: true,
        doop: true,
        dayOfWeek: true,
        peakWeek: peakWeekHidden,
        goBack: true,
        nextPrev: !NextPrevRequest
      },
      airportseasonSelectorConfig: {
        selectCodeType: true,
        dropdownMultiSelect: false
      }
    },
    [PageId.AvailSeasonHour]: {
      codeType: CodeType.IATA,
      pageTitle: seasonHour,
      flightSelectorConfig: {
        terminal: terminalHidden,
        overlayQuotaConstraints: overlayQuotaConstraintsHidden,
        useHourlyConstraints,
        date: true,
        peakWeek: peakWeekHidden,
        nextPrev: !NextPrevRequest,
        goBack: true
      },
      airportseasonSelectorConfig: {
        selectCodeType: true,
        dropdownMultiSelect: false
      }
    },
    [PageId.AvailBaseline]: {
      codeType: CodeType.IATA,
      pageTitle: baselinePeakWeek,
      flightSelectorConfig: {
        terminal: terminalHidden,
        overlayQuotaConstraints: overlayQuotaConstraintsHidden,
        adt: true,
        doop: true,
        dayOfWeek: true,
        hour: true,
        useHourlyConstraints: true,
        peakWeek: true,
        nextPrev: true,
        goBack: true
      },
      airportseasonSelectorConfig: {
        selectCodeType: true,
        dropdownMultiSelect: false
      }
    },
    [PageId.DetailWeek]: {
      codeType: CodeType.IATA,
      pageTitle: detailWeek,
      flightSelectorConfig: {
        terminal: terminalHidden,
        overlayQuotaConstraints: overlayQuotaConstraintsHidden,
        adt: true,
        doop: true,
        dayOfWeek: true,
        useHourlyConstraints,
        peakWeek: peakWeekHidden
      },
      airportseasonSelectorConfig: {
        selectCodeType: true,
        dropdownMultiSelect: false
      }
    },
    [PageId.DetailWeekOOH]: {
      codeType: CodeType.IATA,
      pageTitle: detailWeekOOH,
      flightSelectorConfig: {
        terminal: terminalHidden,
        overlayQuotaConstraints: overlayQuotaConstraintsHidden,
        adt: true,
        doop: true,
        dayOfWeek: true,
        useHourlyConstraints,
        peakWeek: peakWeekHidden
      },
      airportseasonSelectorConfig: {
        selectCodeType: true,
        dropdownMultiSelect: false
      }
    },
    [PageId.DetailSeason]: {
      codeType: CodeType.IATA,
      pageTitle: detailSeason,
      flightSelectorConfig: {
        terminal: terminalHidden,
        overlayQuotaConstraints: overlayQuotaConstraintsHidden,
        useHourlyConstraints: false,
        date: true,
        peakWeek: peakWeekHidden
      },
      airportseasonSelectorConfig: {
        selectCodeType: true,
        dropdownMultiSelect: false
      }
    }
  }
}
